export default __webpack_public_path__ + "static/media/pc1.8ebe1380.jpg";